
// models
import { Protocol } from '../../../../models/Entities/Protocols/Protocol';
import { Practitioner } from '../../../../models/Entities/Practitioners/Practitioner';

// stores
import * as PractitionerStore from '../../../../redux/middleware/PractitionerMiddleware';
import * as ProtocolsStore from '../../../../redux/middleware/MedicalProtocolMiddleware';

// state
import { AppState } from '../../../../redux/reducers';


//#region Props

interface IProps {
    PractitionerId: string | undefined;
}

interface ConnectedProps {
    isLoading: boolean;
    successLoading: boolean;
    error: string | null;
    practitioner: Practitioner | null;
    practitionerProtocols: Protocol[] | null;
}

interface MedicalServicesDispatchProps {
    GetPractitionerById: typeof PractitionerStore.actionCreators.GetPractitionerById;
    GetProtocolsByPractitionerId: typeof ProtocolsStore.actionCreators.GetProtocolsByPractitionerId;
    GetAllMedicalProtocols: typeof ProtocolsStore.actionCreators.GetAllMedicalProtocols;
}

export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const CurrentPractitioner = state.Practitioners?.list.find((practitioner: Practitioner) => practitioner.userId === ownProps.PractitionerId);
    
    return {
        isLoading: state.Practitioners?.isLoadingOne || state.Practitioners?.isLoadingAll || state.MedicalProtocols?.isLoadingAll,
        successLoading: state.Practitioners?.successLoadingOne || state.Practitioners?.successLoadingAll || state.MedicalProtocols?.successLoadingAll,
        error: state.Practitioners?.error || state.MedicalProtocols?.error,
        practitioner: CurrentPractitioner,
        practitionerProtocols: CurrentPractitioner?.Protocols
    }
};

export const mapDispatchToProps = {
    ...ProtocolsStore.actionCreators,
    ...PractitionerStore.actionCreators,
};

